<div class="simpleclock">
	@if (optional) {
		<div class="time no-value" [ngClass]="{ selected : minuteSelected == undefined && hourSelected == undefined }" (click)="unsetHourAndMinute()">{{ 'time-picker.time-not-set' | translate }}</div>
	}
	@for (hour of hourSelector; track hour) {
		<div class="time" [ngClass]="{ selected : hourSelected == hour }" (click)="selectHour(hour)">{{ hour | number:'2.0-0' }} </div>
	}
	<div class="minute-selector">
		@for (minute of minuteSelector; track minute) {
			<div class="time" [ngClass]="{ selected : minuteSelected == minute }" (click)="selectMinute(minute)">{{ minute | number:'2.0-0' }}</div>
		}
	</div>
</div>
